import { useSupabaseLoader } from "../../../server/supabase/hooks";

import type { RecentlyEditedType } from "./use-recently-edited";

/** The most counted of a feed; any more show as this many and more. */
export const COUNT_CAP = 100;

/**
 * What Recently edited lists of `entityType`, or of every kind, with My Content only off, up to one
 * past `COUNT_CAP`: a page of recently_edited is counted, so it's exactly what the feed shows.
 */
export function useRecentlyEditedTotal(
  entityType?: RecentlyEditedType,
): ReturnType<typeof useSupabaseLoader<number>> {
  return useSupabaseLoader(
    async ({ supabase, account_id }) => {
      const { data, error } = await supabase
        .rpc("recently_edited", {
          account_id_: account_id,
          size_: COUNT_CAP + 1,
          offset_: 0,
          user_edited_: false,
          ...(entityType && { entity_type_: entityType }),
        })
        .select("id");
      if (error) throw error;

      return data.length;
    },
    [entityType],
  );
}

/**
 * Upcoming sends with My Content only off, up to one past `COUNT_CAP`: only
 * upcoming_communications can tell what's upcoming, so a page of them is counted.
 */
export function useUpcomingSendsTotal(): ReturnType<typeof useSupabaseLoader<number>> {
  return useSupabaseLoader(async ({ supabase, account_id }) => {
    const { data, error } = await supabase
      .rpc("upcoming_communications", {
        account_id_: account_id,
        size_: COUNT_CAP + 1,
        offset_: 0,
        user_edited_: false,
      })
      .select("id");
    if (error) throw error;

    return data.length;
  }, []);
}
